module.exports = {
  MESSENGER: 'messenger',
  SMS: 'sms',
  WHATSAPP: 'whatsapp',
  EMAIL: 'email',
  PUSH: 'push'
}
